import styled from '@emotion/styled'
import { css } from '@emotion/react'
import React from 'react'

const dynamicStyle = props =>
  css`
    color: ${props.color};
  `

const Peragraph = styled.p`
  color: #ffffff;
  font-size: 15px;
  font-family: 'poppins';
  font-weight: 300;
  margin-bottom: ${props => props.mb};
  margin-top: ${props => props.mt};
  max-width: ${props => props.maxWidth};

  @media (min-width: 900px) and (max-width: 1020px)  {
    max-width: 450px
  }
`

export const Text = (props) => {
  return (
    <Peragraph className='text-light' maxWidth={props.maxWidth ? props.maxWidth : '100%'} mb={props.mb ? props.mb : '1.5rem'} mt={props.mt ? props.mt : '0rem'}>{props.children}</Peragraph>
  )
}
